const stats = [
  { value: '42,318', label: '在线瓜友' },
  { value: '37', label: '今日快讯' },
  { value: '1,206', label: '活跃讨论' },
];

export default function HeroSpread() {
  return (
    <section className="border-b border-background-200 bg-background-50">
      <div className="mx-auto max-w-[1280px] px-4 py-12 md:px-6 md:py-20">
        <div className="grid grid-cols-1 items-start gap-10 lg:grid-cols-12 lg:gap-14">
          {/* 左栏：文 */}
          <div className="lg:col-span-7 animate-fadeUp">
            <div className="flex items-center gap-3">
              <span className="font-label text-[11px] tracking-[0.3em] text-primary-600">封面故事 / COVER STORY</span>
              <span className="h-px flex-1 bg-background-300" />
            </div>

            <h1 className="mt-6 font-heading text-4xl font-black leading-[1.15] tracking-tight text-foreground-950 sm:text-5xl md:text-6xl">
              把全网的热闹，
              <br />
              端进你的<span className="text-primary-600">讨论区</span>
            </h1>

            <p className="mt-6 max-w-xl text-base leading-loose text-foreground-600 md:text-[17px]">
              黑料吃瓜是给瓜友准备的在线吃瓜基地。从一条实时爆料开始，到一场讨论区的观点交锋，再到一个随时在线的瓜友群——
              热门话题、新鲜料、深度八卦，都收在这一页里。进来，就不会错过任何一个大瓜。
            </p>

            <div className="mt-8 flex flex-col gap-3 sm:flex-row">
              <a
                href="#community"
                className="flex cursor-pointer items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-7 py-3.5 font-label text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
              >
                <i className="ri-group-line" />
                加入瓜友群
              </a>
              <a
                href="#topics"
                className="flex cursor-pointer items-center justify-center gap-2 whitespace-nowrap rounded-md border border-foreground-300 px-7 py-3.5 font-label text-sm font-medium text-foreground-800 transition-colors hover:bg-background-100"
              >
                <i className="ri-chat-3-line" />
                进入讨论区
              </a>
            </div>

            <dl className="mt-10 flex flex-wrap gap-x-10 gap-y-5 border-t border-background-200 pt-6">
              {stats.map((item) => (
                <div key={item.label}>
                  <dt className="font-label text-[11px] tracking-widest text-foreground-500">{item.label}</dt>
                  <dd className="mt-1 font-heading text-2xl font-black text-foreground-950 md:text-3xl">{item.value}</dd>
                </div>
              ))}
            </dl>
          </div>

          {/* 右栏：图 */}
          <div className="lg:col-span-5 animate-fadeUp" style={{ animationDelay: '120ms' }}>
            <figure className="flex flex-col">
              <div className="relative w-full overflow-hidden rounded-lg bg-background-200">
                <img
                  src="https://readdy.ai/api/search-image?query=Editorial%20magazine%20cover%20still%20life%20of%20a%20cozy%20late%20night%20writing%20desk%20with%20a%20vintage%20radio%2C%20scattered%20newspapers%2C%20a%20stack%20of%20photos%2C%20an%20open%20notebook%20and%20a%20cup%20of%20tea%2C%20warm%20amber%20lamp%20light%20on%20textured%20cream%20paper%20backdrop%2C%20stylized%20artistic%20collage%20aesthetic%2C%20muted%20cream%20and%20oxblood%20color%20palette%2C%20subtle%20film%20grain%2C%20restrained%20elegant%20composition%2C%20soft%20depth&width=900&height=1080&seq=heiliaochigua-cover-hero&orientation=portrait"
                  alt="黑料吃瓜本期封面主题图"
                  title="黑料吃瓜 瓜友群的深夜围观现场"
                  className="h-full w-full object-top"
                  style={{ aspectRatio: '900 / 1080' }}
                />
                <span className="absolute left-4 top-4 rounded-full bg-primary-500 px-3 py-1 font-label text-[11px] tracking-widest text-background-50">
                  VOL.128
                </span>
              </div>
              <figcaption className="mt-4 flex items-center gap-2 font-label text-xs text-foreground-500">
                <span className="h-1.5 w-1.5 rounded-full bg-accent-500" />
                本期封面 · 深夜编辑部与瓜友的围观现场
              </figcaption>
            </figure>
          </div>
        </div>
      </div>
    </section>
  );
}